import { Reducer } from 'redux';

import { loadApp } from '../services/app';
import { ActionTypes } from '../types/action-types';
import { ActionObject, IApp } from '../types/app';

export default ((state = loadApp(), action: ActionObject): IApp => {
  switch (action.type) {
    case ActionTypes.PROFILE_DRAWER_SHOWED:
      return {
        ...state,
        drawerOpen: action.open,
      };
    case ActionTypes.PROFILE_PROJECTS_LOADED:
      return {
        ...state,
        projects: action.projects,
      };
  }
  return {...state};
}) as Reducer<IApp>;



// WEBPACK FOOTER //
// ./src/reducers/app.ts